import zhCN from './zh-cn';
import en from './en';
import { useLocale } from '../../utils/i18n';

export interface FaqItem {
  id: string,
  title: string,
  content: string,
}

const faqs: Record<string, FaqItem[]> = { 'zh-cn': zhCN, en };

export function useFaqs() {
  const [locale] = useLocale();
  return faqs[locale];
}
